import { render } from "./KeyValueField.vue?vue&type=template&id=1e9085fd"
import script from "./KeyValueField.vue?vue&type=script&lang=js"
export * from "./KeyValueField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KeyValueField.vue"]])

export default __exports__